import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAppConfig } from '../Config/app-config.model';
import { AnalystModel } from 'src/app/shared/model/Analyst.model';

@Injectable({
  providedIn: 'root'
})
export class AnalystService {

  constructor(private httpParameter: HttpClient, @Inject('appconfig') private config: IAppConfig) { }

  GetAnalysts(): Observable<AnalystModel[]> {
    return this.httpParameter.get<any>(`${this.config.ApiConfig.API_ENDPOINT}Analyst`);
  }
}
